/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Kuvaa ei voitu ladata',
    ERROR: 'Virhe'
  },
  HEADER: {
    DESCRIPTION: 'Kuvaus',
    END_DATE: 'Kunnes',
    ID: 'Id',
    START_DATE: 'Koska',
    TITLE: 'Otsikko'
  },
  LABEL: {
    ACTIVES: 'Aktiiviset kampanjat',
    CAMPAIGNS_SIGN_OR: 'Tai',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Kuponki',
    DESCRIPTION: 'Kuvaus',
    DESIGN_REQUESTS: 'Suunnittelupyynnöt',
    DESIGN_REQUESTS_ACTIVES: 'Aktiiviset suunnittelupyynnöt',
    DESIGN_REQUESTS_TERMINATED: 'Valmistuneet suunnittelutilaukset',
    DETAIL: 'Yksityiskohdat',
    END_DATE: 'Kunnes',
    FILES_TITLE: 'Kampanjan resurssit',
    FILES_TITLE_DESIGN_REQUEST: 'Suunnittelun hakemiseen liittyvät resurssit',
    FINISHED: 'Valmis',
    FINISHED_DESIGN_REQUEST: 'Lopullinen',
    GENERATED: 'Luotu',
    GENERIC_DESIGN: 'Yleinen muotoilu',
    ID: 'Id',
    IN_PROGRESS: 'Käynnissä',
    NO_ROWS_CAMPAIGNS: 'Ei kampanjoita',
    NO_ROWS_DESIGN_REQUESTS: 'Ei suunnittelupyyntöjä',
    OFFER: 'Tarjous',
    PREVIOUS_LEVEL: 'Edellinen taso',
    START_DATE: 'Koska',
    STATUS: 'Valtio',
    TERMINATED: 'Valmiit kampanjat',
    TITLE: 'Otsikko',
    VALUE: 'Arvo'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION: 'Tähän kampanjaan ei ole liitetiedostoja (vielä).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Tähän mallihakemukseen ei ole (vielä) liitteitä.',
    ATTACHMENT_TITLE: 'Ei liitteitä'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
